// we're in a deeper folder than fields.js - assume it is loaded
PD.forms.fields.HiddenField = (function(){
  function HiddenField(cfg, index, form) {
    this._super.apply(this, arguments); // call generic field constructor
  }
  HiddenField.prototype = {
    _rows: 0,
    _template: "<input type='hidden' id='<%=id%>' name='<%=name%>'>",
    _feedback: null,

    getValue: function(){
      return this.$elm.val();
    },
    setValue: function(val){
      this.$elm.val(val);
      return true;
    },
    clearValue: function(){
      this.$elm.val("");
      return true;
    }
  };
  // inherit from generic field
  PD.forms.fields.register(["hidden", "HiddenField"], HiddenField);

  return HiddenField;
})();